import { AxiosError } from "axios";
import api, { API_VERSIONS } from "@/config/api";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import type { CreateDetailedMinutesData } from "@/hooks/mutations/usePostCreateDetailedMinutes";

const postCreateDetailedMinutes = async ({ recordingId }: CreateDetailedMinutesData): Promise<boolean | AxiosError> => {
  try {
    const initialToken = recoverTokenInfo();
    const res = await api.post<boolean | AxiosError>(`/${API_VERSIONS.v0}/recording/${recordingId}/ExtendedMinutes`, null, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${initialToken}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error creating minutes:", error);
    throw error;
  }
};

export default postCreateDetailedMinutes;
